// ── 로그 관리 — 상수 정의 ───────────────────────────────────────────────────

// audit_logs 테이블 컬럼 매핑 (AdminColHeader db prop에 사용)
export const LOG_HEADERS = [
  { label: '#',     db: 'audit_logs.id' },
  { label: '시각',  db: 'audit_logs.created_at' },
  { label: '직원',  db: 'audit_logs.user_id → users.name' },
  { label: '기능',  db: 'audit_logs.path (분류됨)' },
  { label: '메서드', db: 'audit_logs.method' },
  { label: 'PATH',  db: 'audit_logs.path' },
  { label: '상태',  db: 'audit_logs.status_code' },
  { label: 'IP',    db: 'audit_logs.ip_address' },
];

// 기능별 경로 프리셋 (필터 드롭다운에 표시)
// value: API 경로 패턴, 콤마로 구분하면 OR 조건으로 클라이언트 필터
export const FEATURE_PRESETS = [
  { label: '전체 기능',          value: '' },
  { label: '출퇴근',             value: '/api/attendance' },
  { label: '연차',               value: '/api/leaves' },
  { label: '일일콜현황',         value: '/api/tm/calls' },
  { label: '미팅지도',           value: '/api/tm/meeting-map' },
  { label: '로그인 / 로그아웃',  value: '/api/login,/api/logout,/api/auth' },
  { label: '계약 관리',          value: '/api/admin/contracts' },
  { label: '홍보물 관리',        value: '/api/admin/promotional' },
  { label: '직원 관리',          value: '/api/admin/users' },
  // 2026-10-23 IP 관리 → 출퇴근 관리 ☰ 창(/api/admin/ip-scope/…). 서버가 '들어 있으면' 거르므로 한 값으로 옛·새 주소 모두
  { label: 'IP 관리',           value: '/api/admin/ip' },
  { label: '연차 관리(관리자)',   value: '/api/admin/leaves' },
  { label: '출퇴근 관리(관리자)', value: '/api/admin/attendance' },
  { label: '상품/카테고리 설정', value: '/api/admin/ticket-types,/api/admin/product-categories' },
  { label: 'DB 관리',            value: '/api/admin/db' },
  { label: '위장 접속',          value: '/api/admin/impersonate' },
  // 외부 회사 관련 API (외부직원/출퇴근/연차/일일콜현황 + 회사 설정)
  { label: '외부 회사 관리',     value: '/api/admin/ext,/api/admin/external-companies' },
];

// HTTP 메서드 필터 선택지
export const METHOD_OPTIONS = ['ALL', 'GET', 'POST', 'PUT', 'PATCH', 'DELETE'];

// 상태코드 그룹 필터 선택지
export const STATUS_GROUPS = [
  { label: '전체',               value: '' },
  { label: '2xx 성공',           value: '2' },
  { label: '3xx 리다이렉트',     value: '3' },
  { label: '4xx 클라이언트 오류', value: '4' },
  { label: '5xx 서버 오류',      value: '5' },
];

// 페이지당 로그 건수
export const LIMIT = 50;
